var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 314,
    height: 264,
    viewBox: "0 0 314 264",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M150 0.5C222.575 0.5 281.5 59.4253 281.5 132C281.5 204.575 222.575 263.5 150 263.5C77.4253 263.5 18.5 204.575 18.5 132C18.5 59.4253 77.4253 0.5 150 0.5Z",
    fill: "url(#paint0_linear_194_43559)",
    stroke: "#EDF0FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M250 138C250 194.34 204.34 240 148 240C91.66 240 46 194.34 46 138C46 81.66 91.66 36 148 36C204.34 36 250 81.66 250 138Z",
    fill: "url(#paint1_linear_194_43559)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M250 126C250 182.34 204.34 228 148 228C91.66 228 46 182.34 46 126C46 69.66 91.66 24 148 24C204.34 24 250 69.66 250 126Z",
    fill: "url(#paint2_linear_194_43559)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M190 115.5L134.5 168L109.5 145.5",
    stroke: "#00993A",
    strokeWidth: 32,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M190 101.5L134.5 154L109.5 131.5",
    stroke: "white",
    strokeWidth: 32,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M273.998 15.9078L283.574 33.4245L301.091 43L283.574 52.5755L273.998 70.0921L264.423 52.5755L246.906 43L264.423 33.4245L273.998 15.9078Z",
    fill: "#FFCF34"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4979 173.326L31.1584 187.34L45.1717 195L31.1584 202.66L23.4979 216.674L15.8375 202.66L1.82422 195L15.8375 187.34L23.4979 173.326Z",
    fill: "#FFCF34"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M229.042 131L239.66 150.424L259.084 161.042L239.66 171.66L229.042 191.084L218.424 171.66L199 161.042L218.424 150.424L229.042 131Z",
    fill: "#FFCF34"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_194_43559",
    x1: 149.498,
    y1: 263.498,
    x2: 149.498,
    y2: 0.502001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E5F5E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCEBD2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_194_43559",
    x1: 109.532,
    y1: 36,
    x2: 192.662,
    y2: 231.414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7ED208"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3FA93D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008071"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_194_43559",
    x1: 97.4,
    y1: 33.014,
    x2: 203.25,
    y2: 213.304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93D751"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#49C148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AA40"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessCheckmark);
export default __webpack_public_path__ + "static/media/success_checkmark.f695bbf8d8ce9d7a4be5e7660e26e39f.svg";
export { ForwardRef as ReactComponent };